import type { Prototype } from "../prototype-types";

export const johnIntraterPrototypes: Prototype[] = [
  {
    id: "brand-storefront-template",
    name: "Brand Storefront",
    path: "/ji/brand-storefront",
    description:
      "Faithful port of the retailer-facing brand storefront (Jungle Club): brand header, sticky category tabs + search, filter/sort row, product grid, 'Brands you might like', 'Popular with stores like yours' carousel, and ratings & reviews. Composed from reusable brand-storefront component patterns.",
    owner: "John Intrater",
    createdAt: "2026-06-22",
    lastUpdated: "2026-06-22",
    surfaceArea: "Brand",
    category: "template",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/f24bc977854b0f5757f1f77ec56ea1310d86c582ea7619a40d03a4ffe6b83ba7.png",
    creationTool: "claude-code",
    productionReference: "https://www.faire.com/brand/b_tthhaz7z5x",
  },
  {
    id: "playground-1-0-launch-page",
    name: "Playground 1.0 Launch Page",
    path: "/ji/playground-1-0-launch-page",
    description:
      "Highlight a bundle of new product features and improvements for playground.",
    owner: "John Intrater",
    createdAt: "2026-04-26",
    lastUpdated: "2026-04-26",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/22fdc6fedec11746f5adb133d405bba08756ca6dfc4f9ed9aa5c3f47db1816ac.png",
    creationTool: "claude-code",
  },
  {
    id: "compass-super-assistant-poc",
    name: "Compass AI Assistant POC",
    path: "/ji/compass-super-assistant-poc",
    description:
      "End-to-end Compass flow: ideas home → theme detail → tailor + re-rank with AI Assistant → PDP with persistent assistant.",
    owner: "John Intrater",
    createdAt: "2026-04-18",
    lastUpdated: "2026-04-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ad1a971d3fcf0fa4753beb56e8da9af0460e4e9771c06dfd9fb2a621356ec548.png",
    creationTool: "claude-code",
  },
  {
    id: "super-assistant-april-24-flash-session",
    name: "Super Assistant April 24 Flash Session",
    path: "/ji/super-assistant-april-24-flash-session",
    description:
      "Exploring the super assistant meeting a retailer in search results and showing them how it can help",
    owner: "John Intrater",
    createdAt: "2026-04-08",
    lastUpdated: "2026-04-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4235f12ebf5fb38909e7c0d4bb17eb0090a6dd682e816b64d93acea525a19939.png",
    creationTool: "claude-code",
  },
  {
    id: "variant-switcher-v2",
    name: "Variant Switcher V2",
    path: "/ji/variant-switcher-v2",
    description:
      "Anatomy and documentation of the V2 prototype toolbar — vertical icon rail with flyout panels for info, variants, comments, and more.",
    owner: "John Intrater",
    createdAt: "2026-04-05",
    lastUpdated: "2026-04-08",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2bfb74d037c08df76770d75f6740db33ea1de4c98b6479a677c7d47b81a27dbf.png",
    creationTool: "cursor",
  },
  {
    id: "collection-creator",
    name: "Collection Creator",
    path: "/ji/collection-creator",
    description: "Compass collection creator flow for retailers.",
    owner: "John Intrater",
    createdAt: "2026-03-24",
    lastUpdated: "2026-03-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/56cc0678d49baec59f22e109a99490779a165924e13fe8513ef9a2e1cb1a2a49.png",
    creationTool: "cursor",
  },
  {
    id: "b2buy",
    name: "B2Buy",
    path: "/ji/b2buy",
    description: "B2Buy vision exercise",
    owner: "John Intrater",
    createdAt: "2026-03-14",
    lastUpdated: "2026-03-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1c8c9fde99a35a53cba08327cfb56b8fffb0a801d05d6a51d19c3e353fbd774d.png",
    creationTool: "cursor",
  },
  {
    id: "retailer-flash-session-2-27",
    name: "Retailer Flash Session 2.27",
    path: "/ji/retailer-flash-session-2-27",
    description: "Flash session prototype for retailer surface",
    owner: "John Intrater",
    createdAt: "2026-02-26",
    lastUpdated: "2026-02-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ea217dabedbb44c20d836ff226f102da563b4fbfbda991728823073fb2891ea9.png",
    project: "Compass AI",
    creationTool: "cursor",
  },
  {
    id: "intrater-top-5",
    name: "Intrater Top 5",
    path: "/ji/intrater-top-5",
    description: "PD All Hands 2.26.26 presentation",
    owner: "John Intrater",
    createdAt: "2026-02-23",
    lastUpdated: "2026-02-26",
    surfaceArea: "Other",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c5fffa6d5fefbf6e6387dcdaaa71720914c3c877a1350d2e4cd08b0799770c1a.png",
    creationTool: "cursor",
  },
  {
    id: "compass-chat-interaction-details",
    name: "Compass AI Chat Knobs & Levers",
    path: "/ji/compass-chat-interaction-details",
    description:
      "Exploring the tiny interaction nuances and details in AI chat on the PDP.",
    owner: "John Intrater",
    createdAt: "2026-02-23",
    lastUpdated: "2026-02-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/07b6048adeb6736e233aff2d24daf99c933201dbb9b241853dcf2a1e63fc9b20.png",
    project: "Compass AI",
    creationTool: "cursor",
  },
  {
    id: "compass-interaction-exploration",
    name: "Compass Interaction Exploration",
    path: "/ji/compass-interaction-exploration",
    description: "Exploring different interaction approaches to compass chat.",
    owner: "John Intrater",
    createdAt: "2026-02-19",
    lastUpdated: "2026-02-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a115fefe1c6477c1caf00f385f144d42e98403d212307eea8fd47b036a3b0400.png",
    project: "Compass AI",
    creationTool: "cursor",
  },
  {
    id: "pdp-chat-feb-24",
    name: "PDP AI Chat",
    path: "/ji/pdp-chat-feb-24",
    description:
      "Full PDP with the refined Feb 24 Ask Faire chat experience as a floating overlay.",
    owner: "John Intrater",
    createdAt: "2026-02-24",
    lastUpdated: "2026-02-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/235bc4e841e2ee99dea060d5ec20227e969063552efc907225a29ddaac24e48e.png",
    project: "Compass AI",
    creationTool: "cursor",
  },
  {
    id: "compass-buying-assistant",
    name: "Compass Buying Assistant",
    path: "/ji/compass-buying-assistant",
    description:
      "AI buying assistant that transitions from PDP chat to a full page experience with product recommendations.",
    owner: "John Intrater",
    createdAt: "2026-03-06",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/504180be1d81fe2e82d7964fd870ec706c762870f2c996128e544080f2c38663.png",
    project: "Compass AI",
    creationTool: "cursor",
  },
  {
    id: "review-to-accept",
    name: "Review to Accept Iteration",
    path: "/ji/faire/review-to-accept",
    description:
      "Static order detail page showing the Faire+ enrollment banner for accepting orders from large retail partners.",
    owner: "John Intrater",
    createdAt: "2026-02-12",
    lastUpdated: "2025-12-02",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/feefe26c3550ebcb5a10f3249916c75fa155a68f36b004c12caaf4bc79e564bc.png",
    creationTool: "cursor",
  },
  {
    id: "upmarket-retailer-landing",
    name: "Upmarket+ Retailer Landing",
    path: "/ji/upmarket-retailer-landing",
    description:
      "Two-variant prototype exploring vendor setup toolkit for large retail partners. Includes public landing page and logged-in portal with COI request flow.",
    owner: "John Intrater",
    createdAt: "2026-02-02",
    lastUpdated: "2026-03-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1937ec383cf0d41597eea0eb38a2f5a53030a67a425ad9d41e3025070a004757.png",
    creationTool: "claude-code",
  },
  {
    id: "retail-growth-jam",
    name: "Retail Growth Jam",
    path: "/ji/retail-growth-jam",
    description: "Prototype for Retail Growth Jam explorations.",
    owner: "John Intrater",
    createdAt: "2024-12-03",
    lastUpdated: "2025-11-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8173eb45a94fb8855c5a7aab20caebf1177d7ee0ec43469bc83cb5f4c51fbd1c.png",
    creationTool: "cursor",
  },
  {
    id: "faire-plus-landing",
    name: "Faire+ Landing Page",
    path: "/ji/faire/faire-plus",
    description:
      "Wholesale landing page based on Figma design. Features hero with email signup, value propositions (low minimums, 60-day payment, free returns), and retailer showcase.",
    owner: "John Intrater",
    createdAt: "2025-12-11",
    lastUpdated: "2025-12-11",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e49eba75effb21d5cee1e91f6c5b21dff4774d6a93752249f823c14c61270abf.png",
    creationTool: "cursor",
  },
  {
    id: "reactive-brand-onboarding",
    name: "Reactive Brand Onboarding",
    path: "/ji/faire/reactive-onboarding",
    description:
      "Demonstrates how non-Faire+ brands complete compliance requirements when receiving an order from a large retail partner. Features blocking banner, two-step checklist, and modal flows for T&C signing and COI upload.",
    owner: "John Intrater",
    createdAt: "2025-11-24",
    lastUpdated: "2025-12-10",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5af28c283ece7d43cfef32a38731887210cbbc1a6e2c0d35c84560a5143a4b1f.png",
    creationTool: "cursor",
  },
  {
    id: "proactive-faire-plus",
    name: "Proactive Faire+ Onboarding",
    path: "/ji/faire/proactive-faire-plus",
    description:
      "Brand-facing landing page for proactive Faire+ enrollment. Brands can learn about Faire+ benefits and complete onboarding (sign agreement + upload COI) before receiving an Upmarket order.",
    owner: "John Intrater",
    createdAt: "2026-01-20",
    lastUpdated: "2026-02-05",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6cc5485aa4f7ac5ed3729c5ddaf659f76532f797b9188341141d0d420e2884c8.png",
    creationTool: "cursor",
  },
  {
    id: "bulk-editor",
    name: "Bulk Editor Page",
    path: "/ji/faire/bulk-editor",
    description:
      "Bulk product attribute editor for large retail partners. A remix of the existing bulk editor with experimental features for managing product catalogs at scale.",
    owner: "John Intrater",
    createdAt: "2025-11-23",
    lastUpdated: "2025-11-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/53140e8e1b074d48f507bf2008cbde7fdb8f8b5456af6c656af211c352cd3f2a.png",
    creationTool: "claude-code",
  },
  {
    id: "compass-prototype",
    name: "🧭 Compass Prototype (JI)",
    path: "/ji/compass-prototype",
    description:
      "AI-powered product discovery that helps retailers find multiple product types in one search. Features progressive search animation and conversational refinement.",
    owner: "John Intrater",
    createdAt: "2025-11-23",
    lastUpdated: "2025-11-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/20efe67696a81383df4ba9fa3cbf783019cd24dcbfc0ef76cd67ab892232a53e.png",
    creationTool: "cursor",
  },
  {
    id: "orders-list-template",
    name: "Orders List Page",
    path: "/ji/faire/templates/orders",
    description:
      "Brand portal orders list page template. Shows order management interface with filtering, search, and status indicators.",
    owner: "John Intrater",
    createdAt: "2025-12-02",
    lastUpdated: "2025-12-10",
    surfaceArea: "Brand",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6adc723de964e97bb2a5ab1cd33f8ab316a255ff755c5ccf019c1ae592b47bfd.png",
    creationTool: "cursor",
  },
  {
    id: "order-detail-template",
    name: "Order Detail",
    path: "/ji/faire/templates/orders/HYBYWJXJYN",
    description:
      "Brand portal order detail page with New→Unfulfilled state machine. Demonstrates accept flow, ship date input, expected ship date card, and shipping configuration.",
    owner: "John Intrater",
    createdAt: "2025-12-02",
    lastUpdated: "2026-05-07",
    surfaceArea: "Brand",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2a03b894da7cf8101df030fe52521f1b796cb44cdc30bf3bff8d6491eb5391df.png",
    creationTool: "cursor",
  },
  {
    id: "bulk-editor-template",
    name: "Bulk Editor Page",
    path: "/ji/faire/templates/bulk-editor",
    description:
      "Brand portal bulk editor template. Spreadsheet-style interface for editing product attributes like GTINs, weights, and dimensions.",
    owner: "John Intrater",
    createdAt: "2025-12-02",
    lastUpdated: "2025-12-02",
    surfaceArea: "Brand",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c478895b4aaf47358b9f5c86d81328b46b42c51f23b890be0ca2e344057871ef.png",
    creationTool: "cursor",
  },
  {
    id: "products-template",
    name: "Products Page",
    path: "/ji/faire/templates/products",
    description:
      "Brand portal products page template. Product listing with filtering, bulk actions, and status management.",
    owner: "John Intrater",
    createdAt: "2025-12-02",
    lastUpdated: "2025-11-14",
    surfaceArea: "Brand",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4f2e3698e33d273aefbf962c1423a59cdcaaf7d529ee15a7629b9cb89be90b60.png",
    creationTool: "cursor",
  },
  {
    id: "super-assistant-mega-prototype",
    name: "Super Assistant Mega Prototype",
    path: "/ji/super-assistant-mega-prototype",
    description:
      "Unified prototype combining homepage, super assistant, idea detail, PDP, and side chat with scripted AI flows.",
    owner: "John Intrater",
    createdAt: "2026-04-06",
    lastUpdated: "2026-04-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6c1a583e1762b4a947647ac193b405b3dba26771545292af07fc5796e637b3c5.png",
    creationTool: "cursor",
  },
  {
    id: "ai-chat-exploration",
    name: "AI Chat Exploration",
    path: "/ji/ai-chat-exploration",
    description:
      "Scripted AI chat experience exploring Mother's Day display planning with split layout and comparison view.",
    owner: "John Intrater",
    createdAt: "2026-03-27",
    lastUpdated: "2026-04-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/dc0d445b1a3bef211ff1b47b6f0541c3a9877a35c073d924a28548ed5060ccb6.png",
    creationTool: "cursor",
  },
  {
    id: "super-assistant-entry-surface",
    name: "Super Assistant Entry Surface",
    path: "/ji/super-assistant-entry-surface",
    description:
      "Deep dive on the entry surface for the Super Assistant experience.",
    owner: "John Intrater",
    createdAt: "2026-04-03",
    lastUpdated: "2026-04-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e590e97549bed06bf31ab5af2126da501f6b46ea95553873eadf506421c7e250.png",
    creationTool: "cursor",
  },
  {
    id: "ji-super-assistant-compare",
    name: "Super Assistant Compare",
    path: "/ji/super-assistant-compare",
    description:
      "Using the super assistant to compare 3 different products from the PDP page.",
    owner: "John Intrater",
    createdAt: "2026-05-06",
    lastUpdated: "2026-05-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e3feab6cd8d3f4473281a115e2d8d8a5d940e47b3945d268799d9f1b619b48c5.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-pdp-compare-exploration",
    name: "PDP Compare Exploration",
    path: "/ji/pdp-compare-exploration",
    description: "",
    owner: "John Intrater",
    createdAt: "2026-05-14",
    lastUpdated: "2026-05-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8e1f536344d9d398a193c45b6b6d02c992d47d5ba0c76cf801b40896be9b0b9f.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-compare-products",
    name: "Compare Products",
    path: "/ji/compare-products",
    description: "",
    owner: "John Intrater",
    createdAt: "2026-05-19",
    lastUpdated: "2026-05-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/22f6630b27c5f4c23fc4f8609b829ba157e80c96e06ecb6143a3d5dbd90495d5.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-compare-products-iteration",
    name: "Compare Products Iteration",
    path: "/ji/compare-products-iteration",
    description: "",
    owner: "John Intrater",
    createdAt: "2026-05-27",
    lastUpdated: "2026-05-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/ca342cf42798aa0b779fa99aeb30f8b9fb8fdcd03ce5c8d3d6ee0071b9343d7f.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-compare-products-exploration-2",
    name: "Compare Products Exploration 2",
    path: "/ji/compare-products-exploration-2",
    description: "",
    owner: "John Intrater",
    createdAt: "2026-05-28",
    lastUpdated: "2026-05-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/791a04eb806dc500a0c10cf1631d121a77da684d6ade54e417e6a2fe7cf29025.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-compare-products-in-situ",
    name: "Compare Products In-Situ",
    path: "/ji/compare-products-in-situ",
    description: "",
    owner: "John Intrater",
    createdAt: "2026-06-01",
    lastUpdated: "2026-06-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/11fcedc889159c752064e353b4f011dbd4cb5adf77a42d19d543a0587bfddc05.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-ask-your-assistant-alt-entry",
    name: "Ask Your Assistant Alt Entry",
    path: "/ji/ask-your-assistant-alt-entry",
    description:
      "Forked PDP facade — canvas for exploring an alternate entry point to the assistant.",
    owner: "John Intrater",
    createdAt: "2026-06-02",
    lastUpdated: "2026-06-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f629df054e78a2ecddc055c751492011bea49f5c66628ae06fc4c78fdd7b13b0.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-ask-your-assistant-prominent",
    name: "Ask Your Assistant Prominent",
    path: "/ji/ask-your-assistant-prominent",
    description:
      "In-situ PDP with the always-on gradient (no glow) Ask Your Assistant bar — forked to a single prominent treatment.",
    owner: "John Intrater",
    createdAt: "2026-06-09",
    lastUpdated: "2026-06-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ji-ask-your-assistant-prominent.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-retailer-pdp",
    name: "Retailer PDP",
    path: "/ji/retailer-pdp",
    description:
      "Faithful port of the retailer PDP: sticky brand header, image mosaic, product details rail with inline 'Your Assistant' entry, and the Compare products section.",
    owner: "John Intrater",
    createdAt: "2026-06-15",
    lastUpdated: "2026-06-15",
    surfaceArea: "Retailer",
    category: "template",
    patternType: "page",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/48e18303af01b8e52f5b61fc14959acb05cc017954a4c3b7e4d3919cbd53a07c.png",
    creationTool: "claude-code",
    productionReference: "Retailer product details page",
    variants: [
      {
        id: "default",
        name: "Default",
        description:
          "Faithful port of the retailer PDP: sticky brand header, image mosaic, product details rail with inline 'Your Assistant' entry, and the Compare products section.",
        previewPath: "/ji/retailer-pdp",
      },
    ],
  },
  {
    id: "ji-retailer-pdp-assistant",
    name: "Retailer PDP — Assistant open",
    path: "/ji/retailer-pdp-assistant",
    description:
      "The retailer PDP with the Compass 'Your Assistant' panel docked open on the left, pushing the page content to the right — the in-use state of the assistant on a product page.",
    owner: "John Intrater",
    createdAt: "2026-06-15",
    lastUpdated: "2026-06-15",
    surfaceArea: "Retailer",
    category: "template",
    patternType: "page",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9ccf027a7d603e35bf6adf085e56e9bbfd53f09c9caf6c7745009a29d2f273bb.png",
    creationTool: "claude-code",
    productionReference: "Retailer PDP with Compass assistant docked open",
    variants: [
      {
        id: "default",
        name: "Default",
        description:
          "The retailer PDP with the Compass 'Your Assistant' panel docked open on the left, pushing the page content to the right — the in-use state of the assistant on a product page.",
        previewPath: "/ji/retailer-pdp-assistant",
      },
    ],
  },
  {
    id: "ji-visualize-compare-in-chat",
    name: "Visualizing compare in chat",
    path: "/ji/visualize-compare-in-chat",
    description:
      "Visualizing what it looks like when a user clicks compare similar products and the super assistant side panel opens up",
    owner: "John Intrater",
    createdAt: "2026-06-16",
    lastUpdated: "2026-06-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/1c688ce637ce2fdfd1e99be3281e61664fbdf0c038153d83f96eb5c06cea02a8.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-retailer-assistant-fab",
    name: "Retailer Assistant FAB",
    path: "/ji/retailer-assistant-fab",
    description: "Floating action button concept for the retailer assistant",
    owner: "John Intrater",
    createdAt: "2026-06-17",
    lastUpdated: "2026-06-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/797c022a17ef51bfff29569e01882db058972d16c0ca1452557162801c8bb1e8.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-brand-storefront-assistant",
    name: "Brand Storefront — Assistant open",
    path: "/ji/brand-storefront-assistant",
    description:
      "The retailer-facing Jungle Club brand storefront with the Compass 'Your Assistant' panel docked open on the left, pushing the storefront right. Explores how the assistant coexists with the page's other surfaces — category tabs, the filter rail, and the right-hand side cart — when several are open at once. The scripted Q&A is anchored to the brand (bestsellers, brand minimum, lead times, margins).",
    owner: "John Intrater",
    createdAt: "2026-06-24",
    lastUpdated: "2026-06-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/589be49456b27c84677c93f621355ef4b8813b0bb1f6f850037fb126330eba1d.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-brand-storefront-assistant-deep-dive",
    name: "Brand Storefront Assistant — Deep Dive",
    path: "/ji/brand-storefront-assistant-deep-dive",
    description:
      "A deeper-dive exploration of the retailer assistant on the brand storefront, focused on specific interaction-pattern and entry-point options aligned with the team. Builds on the BP Category navigation + assistant layout.",
    owner: "John Intrater",
    createdAt: "2026-06-26",
    lastUpdated: "2026-06-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/40235d3d8323d09796d26a056a2b5154686b147bdecf9e5d958b23645537d53b.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-retailer-pdp-assistant-v-2",
    name: "Retailer PDP — Assistant open v2",
    path: "/ji/retailer-pdp-assistant-v-2",
    description:
      "Fork of the Retailer PDP with the Compass assistant panel docked open — new exploration branch.",
    owner: "John Intrater",
    createdAt: "2026-07-20",
    lastUpdated: "2026-07-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0cc07e8221aa7227ae6a9f0ef20a99f73828e1b8d25410caa421780e7ab25b1c.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-assistant-category-nav",
    name: "Assistant Category Nav Refinement",
    path: "/ji/assistant-category-nav",
    description:
      "Explores how the retailer assistant can help refine category navigation results.",
    owner: "John Intrater",
    createdAt: "2026-07-31",
    lastUpdated: "2026-07-31",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9d6faeb3d85d90a18b55be5c51cdf2bc8e35511b361f06e3c00983d40d0fb2b7.png",
    project: "Compass AI",
    creationTool: "claude-code",
  },
  {
    id: "ji-assistant-refine-canvas",
    name: "Assistant Refinement Canvas",
    path: "/ji/assistant-refine-canvas",
    description:
      "Full-page assistant canvas where each refinement appends its own grid — entered from a hover-expanding pill on a category page, and narrowing into a docked rail beside a product page.",
    owner: "John Intrater",
    createdAt: "2026-08-03",
    lastUpdated: "2026-08-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bcf0ba9ab8f08d9e85385ebef65403bf9ee7c4d5c65418a285ccfc4b35bb3490.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-assistant-compare-canvas",
    name: "Assistant Compare Canvas",
    path: "/ji/assistant-compare-canvas",
    description:
      "Compare products picked straight off the bestsellers grid — a FAB turns the results wall into a selection surface, and the comparison opens in the full-page assistant canvas rather than the side panel.",
    project: "Compass AI",
    owner: "John Intrater",
    createdAt: "2026-08-06",
    lastUpdated: "2026-08-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ji-assistant-compare-canvas.png",
    creationTool: "claude-code",
  },
  {
    id: "ji-playground-brand-alignment",
    name: "Playground Brand Alignment",
    path: "/ji/playground-brand-alignment",
    description:
      "1:1 preview of the Brand Evolution browse shell from PR 79606 — live Feed, dock, Patterns, Workspaces, and Resources — so it can be reviewed in Playground without merging the stacked shell PRs.",
    owner: "John Intrater",
    createdAt: "2026-08-20",
    lastUpdated: "2026-08-21",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/23f29ae0529c7da33ba206232f858c4f84d916bfdf1151eac15df742c7fd80c2.png",
    creationTool: "cursor",
  },
  {
    id: "ji-assistant-search-canvas",
    name: "Assistant Search Canvas",
    path: "/ji/assistant-search-canvas",
    description: "Homepage → halloween search → canvas with two opening pills",
    project: "Compass AI",
    owner: "John Intrater",
    createdAt: "2026-08-23",
    lastUpdated: "2026-08-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/72ddce0618f8ebba23da22c79ca0caf2786a8dc33f480e4043f365d8e74cfdce.png",
    creationTool: "cursor",
  },
  {
    id: "ji-assistant-compare-v2",
    name: "Assistant Compare v2",
    path: "/ji/assistant-compare-v2",
    description:
      "Production PDP “Compare similar products” opens in the assistant rail, then Explore more morphs into the full-page compare canvas with the same set — chat to tweak dimensions, drill into a PDP, expand back.",
    project: "Compass AI",
    owner: "John Intrater",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ji-assistant-compare-v2.png",
    creationTool: "cursor",
  },
  {
    id: "ji-canvas-from-pdp",
    name: "Canvas from PDP",
    path: "/ji/canvas-from-pdp",
    description:
      "Start on a PDP, ask from a pill, then Find similar but cheaper opens a canvas of cheaper similar products.",
    project: "Compass AI",
    owner: "John Intrater",
    createdAt: "2026-09-08",
    lastUpdated: "2026-09-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9d6faeb3d85d90a18b55be5c51cdf2bc8e35511b361f06e3c00983d40d0fb2b7.png",
    creationTool: "cursor",
  },
  {
    id: "ji-retailer-assistant-more-like-this",
    name: "Retailer Assistant More Like This",
    path: "/ji/retailer-assistant-more-like-this",
    description:
      "Fork of Canvas from PDP for More Like This. Start on a PDP, ask from a pill, then Find similar but cheaper opens a canvas of cheaper similar products.",
    project: "Compass AI",
    owner: "John Intrater",
    createdAt: "2026-09-17",
    lastUpdated: "2026-09-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ji-retailer-assistant-more-like-this.png",
    creationTool: "cursor",
  },
  {
    id: "ji-retailer-assistant-more-like-this-uxr",
    name: "Retailer Assistant More Like This UXR",
    path: "/ji/retailer-assistant-more-like-this-uxr",
    description:
      "Research fork of Retailer Assistant More Like This, locked to one configuration for a UXR session: a shortlist preview in the rail, a soft-shadowed floating docked panel, a full-page canvas, and stacked narrative results.",
    project: "Compass AI",
    owner: "John Intrater",
    createdAt: "2026-09-22",
    lastUpdated: "2026-09-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "/images/thumbnails/ji-retailer-assistant-more-like-this-uxr.png",
    creationTool: "cursor",
  },
  {
    id: "ji-ra-more-like-this-v2",
    name: "RA More Like This v2",
    path: "/ji/ra-more-like-this-v2",
    description:
      "Fork of Retailer Assistant More Like This cut down to the configuration under study: a mosaic or shortlist preview in the rail, a soft-shadowed floating docked panel, a full-page canvas, and stacked narrative results.",
    project: "Compass AI",
    owner: "John Intrater",
    createdAt: "2026-09-23",
    lastUpdated: "2026-09-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/c88b55a2380fa5ce21ab130980dc26a20b05b435c7576ef6076b0c125ac1426b.png",
    creationTool: "cursor",
  },
  {
    id: "ji-elevation-exploration-old-playground",
    name: "Elevation exploration old playground",
    path: "/ji/elevation-exploration-old-playground",
    description: "",
    owner: "John Intrater",
    createdAt: "2026-09-25",
    lastUpdated: "2026-09-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ji-elevation-exploration-old-playground.png",
    creationTool: "cursor",
  },
];
